import { FC } from "react";
import { observer } from "mobx-react";
import { ArticlesOfAssociationForm } from "./articlesofassociationDomain";
import { VBox } from "../../components-v2/Box";

import { useTranslation } from "../../stores/RootStoreContext";

export const ArticlesOfAssociationView: FC<{ form: ArticlesOfAssociationForm }> = observer(() => {
  const { t } = useTranslation();
  return (
    <VBox gap={"md"}>
      <div>{t("documents.articlesofassociation.preview")}</div>
    </VBox>
  );
});
